import { firma, pakete, empfehlung, kleingedrucktes } from '../content';
import './flyer.css';

/**
 * Angebotsflyer "Manuel Schneider Dienstleistungen" - A5 einseitig.
 *
 * WARUM keine Fussnotenzeichen: content.ts ist bewusst so aufgebaut, dass
 * jede Bedingung (z.B. Kuendigungsfrist) direkt in der Zeile des Pakets
 * steht, das sie betrifft. Eine hochgestellte Ziffer waere hier reine
 * Redundanz - und ein Risiko, dass Ziffer und Fussnote beim naechsten
 * Update auseinanderlaufen.
 */
export function Flyer() {
  return (
    <div className="flyer-page">
      <article className="flyer" aria-label="Angebotsflyer">
        <header className="flyer__head">
          <p className="flyer__wordmark">{firma.name}</p>
          <p className="flyer__claim">{firma.claim}</p>
        </header>

        <ul className="flyer__packages">
          {pakete.map((paket) => (
            <li key={paket.name} className="flyer__package">
              <div className="flyer__package-head">
                <p className="flyer__package-name">{paket.name}</p>
                <p className="flyer__package-price">
                  <span className="flyer__package-price-value">{paket.preis}</span>
                  <span className="flyer__package-price-takt">{paket.takt}</span>
                </p>
              </div>
              <ul className="flyer__package-lines">
                {paket.zeilen.map((zeile) => (
                  <li key={zeile}>{zeile}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>

        <section className="flyer__referral">
          <h2>{empfehlung.titel}</h2>
          <p>{empfehlung.text}</p>
        </section>

        <footer className="flyer__footer">
          {/* Vervielfaeltigtes Dokument: die ALLGEMEINE Adresse, nicht die persoenliche. */}
          <p className="flyer__contact">
            {firma.mailAllgemein} &middot; {firma.telefon} &middot; {firma.web}
          </p>
          <div className="flyer__fineprint">
            {kleingedrucktes.map((zeile) => (
              <p key={zeile}>{zeile}</p>
            ))}
          </div>
        </footer>
      </article>
    </div>
  );
}
